var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-right links"},[_c('img',{staticClass:"logo",attrs:{"src":"/images/logo.jpg","width":"250","alt":""}}),_vm._v(" "),_c('div',{staticClass:"languages"},[_c('LangSwitcher')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }